import Section from "@/components/Section"
import { Box, Typography, useTheme } from "@mui/material"
import { options } from "./mockData"
import BenefitItem from "./components/BenefitItem"

const BenefitsSection = () => {
  const theme = useTheme();
  return (
    <Section pt={{ xs: 10, md: 17.5 }} pb={{ xs: 10, md: 17.5 }} >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            maxWidth: '950px',
            marginBottom: { xs: '40px', md: '80px' }
          }}
        >
          <Typography
            variant='h2'
            sx={{
              marginBottom: { xs: '16px', md: '24px' },
              textAlign: 'center'
            }}
          >
            Key Benefits of Trackmate APIs
          </Typography>
          <Typography
            variant='subtitle1'
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              textAlign: 'center'
            }}
          >
            Trackmate’s API adds value to your existing technology, improving business visibility without adding complexity. Our integrations team works closely with you to make the right connections.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          {options.map((opt, index) => <BenefitItem key={index} {...opt} />)}
        </Box>
      </Box>
    </Section>
  );
};

export default BenefitsSection;
